import { Skill } from 'src/tabs/models/SkillsInterfaces';

export const filterSkillsByKeyWord = (skills: Skill[], keyWord) => {
  return skills.filter((skill) =>
    skill.name.toLowerCase().includes(keyWord.toLowerCase())
  );
};

export const filterSkillsByCategory = (skills: Skill[], category) => {
  if (!category) return skills;
  return skills.filter((skill) => skill.category.value === category);
};
